import React, { useEffect, useMemo } from "react";

import Web3TransmuteFlow from "@/components/Web3/Transmute/Flow";
import { useStoredData, useStoredDataDispatch } from "@/store/Context";

interface LayoutSidebarModeTransmuteProps {
  className?: string;
  headerClassName?: string;
}

export default function LayoutSidebarModeTransmute({ className, headerClassName }: LayoutSidebarModeTransmuteProps) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const transmuteTarget = useMemo(() => storedData.transmute, [storedData.transmute]);

  useEffect(() => {
    if (!transmuteTarget) {
      storedDispatch({ type: "closeOverlay" });
    }
  }, [storedDispatch, transmuteTarget]);

  return transmuteTarget && <Web3TransmuteFlow className={className} headerClassName={headerClassName} transmuteTarget={transmuteTarget} />;
}
